import React, { useEffect, useState } from "react";
// import { getGarmentPack } from "../../services/categoryAndAppService/getGarmentPack";
import {
  getGarmentPack,
  getStoreGarmentCategoryServicesByPriceId,
} from "../../services/GarmentCategory/GarmentCategory";
import { InputText } from "primereact/inputtext";
import { FloatLabel } from "primereact/floatlabel";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { addItemToCart, addMoreItemToOrder, addMoreItemToOrderB2BOrder } from "../../services/Cart/addItemToCart";
import BookNewOrderModal from "./BookNewOrderModal";
import { useNavigate } from "react-router-dom";
import { getLocalGarmentPack } from "../../utils/localStorage";

const { innerWidth: width, innerHeight: height } = window;

const BottomSheetViewForm = ({
  selectedGarment,
  onAddToCart,
  onClose,
  storeId,
  storeCustomerId,
  selectedPriceId,
  BookingType,
  offerPriceEnabled,
  enabledAutoSelectAppService,
  storeUserId,
  brandId,
  bookingOrderId,
  storeGarmentRemarksData,
  enabledPreDefinedRemark,
  garmentMaxProcessCount,
  garmentServiceIcons,
  userProfileData,
  storeGarmentRemarksPriorityData,
  B2BModel,
  enabledAmountRoundOff
}) => {
  const navigate = useNavigate();

  // Trim whitespace from keys in priority array
  const trimmedPriority = storeGarmentRemarksPriorityData.map((key) =>
    key.trim()
  );

  const reorderedGarmentRemarksData = {};

  trimmedPriority.forEach((key) => {
    if (storeGarmentRemarksData[key]) {
      reorderedGarmentRemarksData[key] = storeGarmentRemarksData[key];
    }
  });

  // Optional: If you also want to include any keys in the original data that are **not** in the priority list
  for (const key in storeGarmentRemarksData) {
    if (!trimmedPriority.includes(key)) {
      reorderedGarmentRemarksData[key] = storeGarmentRemarksData[key];
    }
  }

  const { Color, ...rest } = reorderedGarmentRemarksData;
  const FixedColorAttribute = Color;
  const keysArrayRemarksData = Object.keys(rest);
  const [aliasValue, setAliasValue] = useState("");
  const [garmentRemarkValue, setGarmentRemarkValue] = useState("");
  const [packingTypeValue, setPackingTypeValue] = useState("");
  const [selectedGarmentRemarksTypeArray, setSelectedGarmentRemarksTypeArray] =
    useState("");
  const [garmentRemarksTypeValue, setGarmentRemarksTypeValue] = useState("");
  const [garmentRemarksValueData, setGarmentRemarksValueData] = useState("");
  const [selectedRemarksArray, setSelectedRemarksArray] = useState([]);
  const [selectedRemarksArrayOne, setSelectedRemarksArrayOne] = useState([]);
  const [selectedRemarksArrayTwo, setSelectedRemarksArrayTwo] = useState([]);
  const [selectedRemarksArrayThree, setSelectedRemarksArrayThree] = useState(
    []
  );
  const [selectedRemarksArrayColor, setSelectedRemarksArrayColor] = useState(
    []
  );
  const [garmentCategoryId, setGarmentCategoryId] = useState(""); 

  const isRoundOffMode = enabledAmountRoundOff === 0;

  const inputRegex = isRoundOffMode
    ? /^\d*$/
    : new RegExp(`^\\d*\\.?\\d{0,${enabledAmountRoundOff}}$`);

  // New state variables for error messages
  const [aliasError, setAliasError] = useState("");
  const [garmentRemarkError, setGarmentRemarkError] = useState("");
  const [priceError, setPriceError] = useState("");
  const [quantityError, setQuantityError] = useState("");
  const [kGError, setKGError] = useState("");
  const [lengthError, setLengthError] = useState("");
  const [widthError, setWidthError] = useState("");
  const [topUpServiceError, setTopUpServiceError] = useState("");
  const [serviceError, setServiceError] = useState("");
  const [itemGarmentCountError, setItemGarmentCountError] = useState("");

  const [modalVisible, setModalVisible] = useState(false);
  const [modalVisibleContinue, setModalVisibleContinue] = useState(false);
  const [packagingType, setPackagingType] = useState([]);
  const [servicesDataFixed, setServicesDataFixed] = useState([]);
  const [servicesData, setServicesData] = useState([]);

  const [modalStatus, setModalStatus] = useState(false);

  const selectedPackageServiceUnit = servicesData[0]?.serviceUnit;

  
  useEffect(() => {
    fetchAppService();
    // fetchGarmentPack();
    fetchLocalGarmentPack();
  }, [BookingType]);
  
  const fetchLocalGarmentPack = async () => {
        const { garmentPack } = getLocalGarmentPack();
    if (garmentPack && Object.keys(garmentPack).length > 0) {
           
      setPackagingType(garmentPack);
        } else {
      setPackagingType([]);
        }
      };

  const fetchAppService = async () => {
    try {
      // const response = await getGarmentCategoryServices(
      // const response = await getGarmentCategoryServicesByPriceId(
      const response = await getStoreGarmentCategoryServicesByPriceId(
        storeId,
        storeCustomerId,
        selectedGarment.id,
        selectedPriceId
      );
      if (!response.data.error) {
        const modifiedServiceResponse = response.data.map((item, index) => ({
          ...item,
          isSelect: false,
        }));
        setServicesDataFixed(modifiedServiceResponse);
        setServicesData(modifiedServiceResponse);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  // const fetchGarmentPack = () => {
  //   getGarmentPack(brandId, storeId)
  //     .then((response) => {
  //       if (!response.data.error) {
  //         const Res = response.data;
  //         setPackagingType(Res);
  //       }
  //     })
  //     .catch((err) => {
  //       console.error("Error:", err);
  //     });
  // };

  const [attributeOne, setAttributeOne] = useState(
    storeGarmentRemarksData[keysArrayRemarksData[0]]?.map((item) => item.remark)
  );
  const [attributeTwo, setAttributeTwo] = useState(
    storeGarmentRemarksData[keysArrayRemarksData[1]]?.map((item) => item.remark)
  );
  const [attributeThree, setAttributeThree] = useState(
    storeGarmentRemarksData[keysArrayRemarksData[2]]?.map((item) => item.remark)
  );

  const [attributeColor, setAttributeColor] = useState(
    FixedColorAttribute?.map((item) => item.remark)
  );

  const handleKeySelect = (key) => {
    setGarmentRemarksTypeValue(key);
    const remarks = storeGarmentRemarksData[key].map((item) => item.remark);
    // Filter out remarks that are already in selectedRemarksArray
    const filteredRemarks = remarks.filter(
      (remark) => !selectedRemarksArray.includes(remark)
    );
    if (filteredRemarks.length > 0) {
      setSelectedGarmentRemarksTypeArray(filteredRemarks);
    } else {
      setSelectedGarmentRemarksTypeArray([]);
    }
    // if (key === 'Remark') {
    //   setGarmentRemarkValue(remarks.toString());
    // }
    setGarmentRemarksValueData("");
  };

  const handleRemarkSelectOne = (selectedRemark) => {
    setGarmentRemarksValueData(selectedRemark);
    if (garmentRemarksTypeValue === "Remark") {
      setGarmentRemarkValue(selectedRemark);
    } else {
      setSelectedRemarksArrayOne((prevSelectedRemarks) => {
        if (prevSelectedRemarks?.includes(selectedRemark)) {
          // Remove remark if it already exists
          return prevSelectedRemarks.filter(
            (remark) => remark !== selectedRemark
          );
        } else {
          // Add remark if it does not exist
          return [...prevSelectedRemarks, selectedRemark];
        }
      });
      setAttributeOne((prevSelectedRemarks) => {
        if (prevSelectedRemarks?.includes(selectedRemark)) {
          // Remove remark if it already exists
          return prevSelectedRemarks.filter(
            (remark) => remark !== selectedRemark
          );
        }
      });
    }
  };

  const handleRemarkSelectTwo = (selectedRemark) => {
    setGarmentRemarksValueData(selectedRemark);
    if (garmentRemarksTypeValue === "Remark") {
      setGarmentRemarkValue(selectedRemark);
    } else {
      setSelectedRemarksArrayTwo((prevSelectedRemarks) => {
        if (prevSelectedRemarks?.includes(selectedRemark)) {
          // Remove remark if it already exists
          return prevSelectedRemarks.filter(
            (remark) => remark !== selectedRemark
          );
        } else {
          // Add remark if it does not exist
          return [...prevSelectedRemarks, selectedRemark];
        }
      });
      setAttributeTwo((prevSelectedRemarks) => {
        if (prevSelectedRemarks?.includes(selectedRemark)) {
          // Remove remark if it already exists
          return prevSelectedRemarks.filter(
            (remark) => remark !== selectedRemark
          );
        }
      });
    }
  };

  const handleRemarkSelectThree = (selectedRemark) => {
    setGarmentRemarksValueData(selectedRemark);
    if (garmentRemarksTypeValue === "Remark") {
      setGarmentRemarkValue(selectedRemark);
    } else {
      setSelectedRemarksArrayThree((prevSelectedRemarks) => {
        if (prevSelectedRemarks?.includes(selectedRemark)) {
          // Remove remark if it already exists
          return prevSelectedRemarks.filter(
            (remark) => remark !== selectedRemark
          );
        } else {
          // Add remark if it does not exist
          return [...prevSelectedRemarks, selectedRemark];
        }
      });
      setAttributeThree((prevSelectedRemarks) => {
        if (prevSelectedRemarks?.includes(selectedRemark)) {
          // Remove remark if it already exists
          return prevSelectedRemarks.filter(
            (remark) => remark !== selectedRemark
          );
        }
      });
    }
  };

  const handleRemarkSelect = (selectedRemark) => {
    setGarmentRemarksValueData(selectedRemark);
    if (garmentRemarksTypeValue === "Remark") {
      setGarmentRemarkValue(selectedRemark);
    } else {
      setSelectedRemarksArray((prevSelectedRemarks) => {
        if (prevSelectedRemarks?.includes(selectedRemark)) {
          // Remove remark if it already exists
          return prevSelectedRemarks.filter(
            (remark) => remark !== selectedRemark
          );
        } else {
          // Add remark if it does not exist
          return [...prevSelectedRemarks, selectedRemark];
        }
      });
      setSelectedGarmentRemarksTypeArray((prevSelectedRemarks) => {
        if (prevSelectedRemarks?.includes(selectedRemark)) {
          // Remove remark if it already exists
          return prevSelectedRemarks.filter(
            (remark) => remark !== selectedRemark
          );
        }
      });
    }
  };

  const handleRemarkColorSelect = (selectedRemark) => {
    setGarmentRemarksValueData(selectedRemark);
    if (garmentRemarksTypeValue === "Remark") {
      setGarmentRemarkValue(selectedRemark);
    } else {
      setSelectedRemarksArrayColor((prevSelectedRemarks) => {
        if (prevSelectedRemarks?.includes(selectedRemark)) {
          // Remove remark if it already exists
          return prevSelectedRemarks.filter(
            (remark) => remark !== selectedRemark
          );
        } else {
          // Add remark if it does not exist
          return [...prevSelectedRemarks, selectedRemark];
        }
      });
      setAttributeColor((prevSelectedRemarks) => {
        if (prevSelectedRemarks?.includes(selectedRemark)) {
          // Remove remark if it already exists
          return prevSelectedRemarks.filter(
            (remark) => remark !== selectedRemark
          );
        }
      });
    }
  };

  //  need to check again

  const removeRemarksOne = (itemValue) => {
    // const selectedRemovedData = selectedRemarksArrayOne.find(
    //   (item) => item === itemValue
    // );
    const selectedItemsData = selectedRemarksArrayOne.filter(
      (item) => item !== itemValue
    );
    setSelectedRemarksArrayOne(selectedItemsData);
    setAttributeOne((prevSelectedRemarks) => {
      return [...prevSelectedRemarks, itemValue];
    });
  };

  const removeRemarksColor = (itemValue) => {
    // const selectedRemovedData = selectedRemarksArrayColor.find(
    //   (item) => item === itemValue
    // );
    const selectedItemsData = selectedRemarksArrayColor.filter(
      (item) => item !== itemValue
    );
    setSelectedRemarksArrayColor(selectedItemsData);
    setAttributeColor((prevSelectedRemarks) => {
      return [...prevSelectedRemarks, itemValue];
    });
  };

  const removeRemarksTwo = (itemValue) => {
    // const selectedRemovedData = selectedRemarksArrayTwo.find(
    //   (item) => item === itemValue
    // );
    const selectedItemsData = selectedRemarksArrayTwo.filter(
      (item) => item !== itemValue
    );
    setSelectedRemarksArrayTwo(selectedItemsData);
    setAttributeTwo((prevSelectedRemarks) => {
      return [...prevSelectedRemarks, itemValue];
    });
  };
  const removeRemarksThree = (itemValue) => {
    // const selectedRemovedData = selectedRemarksArrayThree.find(
    //   (item) => item === itemValue
    // );
    const selectedItemsData = selectedRemarksArrayThree.filter(
      (item) => item !== itemValue
    );
    setSelectedRemarksArrayThree(selectedItemsData);
    setAttributeThree((prevSelectedRemarks) => {
      return [...prevSelectedRemarks, itemValue];
    });
  };

  const removeRemarks = (itemValue) => {
    const selectedRemovedData = selectedRemarksArray.find(
      (item) => item === itemValue
    );
    const selectedItemsData = selectedRemarksArray.filter(
      (item) => item !== itemValue
    );
    setSelectedRemarksArray(selectedItemsData);
    setSelectedGarmentRemarksTypeArray((prevSelectedRemarks) => {
      return [...prevSelectedRemarks, selectedRemovedData];
    });
  };

  const [priceListId, setPriceListId] = useState("");
  const [garmentName, setGarmentName] = useState("");
  const [description, setDescription] = useState("");
  const [amount, setAmount] = useState("");
  const [categoryName, setCategoryName] = useState("");
  const [qrCodeCount, setQrCodeCount] = useState("");
  const [appServiceName, setAppServiceName] = useState({});
  const [serviceUnitName, setServiceUnitName] = useState({});
  const [servicePrices, setServicePrices] = useState({});
  const [serviceActualPrices, setServiceActualPrices] = useState({});
  const [serviceMinPrices, setServiceMinPrices] = useState({});
  const [serviceMaxPrices, setServiceMaxPrices] = useState({});
  const [serviceCounts, setServiceCounts] = useState({});
  const [serviceCountsKG, setServiceCountsKG] = useState({});
  const [serviceGarmentCountsItem, setServiceGarmentCountsItem] = useState({});
  const [serviceCountsLength, setServiceCountsLength] = useState({});
  const [serviceCountsWidth, setServiceCountsWidth] = useState({});
  const [isGarmentButtonPressed, setIsGarmentButtonPressed] = useState(false);
  const [isGarmentViewDisable, setIsGarmentViewDisable] = useState(false);

  const [handleServiceSelection, setHandleServiceSelection] = useState(false);
  const [handleInputDisable, setHandleInputDisable] = useState(false);
  const [priceEmptyError, setPriceEmptyError] = useState("");

  // Initialize it with the default prices

  useEffect(() => {
    const initialData = servicesData.reduce(
      (data, service) => {
        data.servicePrices[service.id] = service.amount;
        data.serviceUnitName[service.id] = service.serviceUnit;
        // data.serviceMinPrices[service.id] = service.minAmount;
        // data.serviceMaxPrices[service.id] = service.maxAmount;
        data.serviceMinPrices[service.id] = service.brandAppService.minAmount;
        data.serviceMaxPrices[service.id] = service.brandAppService.maxAmount;
        data.serviceCounts[service.id] = 1;
        data.serviceCountsLength[service.id] = 0.1;
        data.serviceCountsWidth[service.id] = 0.1;
        data.serviceCountsKG[service.id] = 0.1;
        data.serviceGarmentCountsItem[service.id] = 1;
        data.appServiceName[service.id] =
          service.brandAppService.appService.name;
        return data;
      },
      {
        servicePrices: {},
        serviceUnitName: {},
        serviceMinPrices: {},
        serviceMaxPrices: {},
        serviceCounts: {},
        serviceCountsLength: {},
        serviceCountsWidth: {},
        serviceCountsKG: {},
        serviceGarmentCountsItem: {},
        appServiceName: {},
      }
    );

    setServicePrices(initialData.servicePrices);
    setServiceUnitName(initialData.serviceUnitName);
    setServiceActualPrices(initialData.servicePrices);
    setServiceMinPrices(initialData.serviceMinPrices);
    setServiceMaxPrices(initialData.serviceMaxPrices);
    setServiceCounts(initialData.serviceCounts);
    setServiceCountsLength(initialData.serviceCountsLength);
    setServiceCountsWidth(initialData.serviceCountsWidth);
    setServiceCountsKG(initialData.serviceCountsKG);
    setServiceGarmentCountsItem(initialData.serviceGarmentCountsItem);
    setAppServiceName(initialData.appServiceName);
  }, []);

  const handleServiceToggle = (itemId) => {
    const updatedServicesData = servicesData.map((item) => {
      if (item.id === itemId) {
        return { ...item, isSelect: true };
      }
      return item;
    });

    setServicesData(updatedServicesData);
    const selectedItemsData = updatedServicesData.filter(
      (item) => item.isSelect
    );
    setGarmentCategoryId(selectedItemsData[0]?.garmentCategory?.id);

    setSelectedServicesItem(selectedItemsData);
    setServiceError("");

    const updatedServicePrices = { ...servicePrices };
    const updatedServiceUnitName = { ...serviceUnitName };
    const updatedServiceMinPrices = { ...serviceMinPrices };
    const updatedServiceMaxPrices = { ...serviceMaxPrices };
    const updatedServiceCounts = { ...serviceCounts };
    const updatedServiceCountsLength = { ...serviceCountsLength };
    const updatedServiceCountsWidth = { ...serviceCountsWidth };
    const updatedServiceCountsKG = { ...serviceCountsKG };
    const updatedServiceGarmentCountsItem = { ...serviceGarmentCountsItem };
    const updatedAppServiceName = { ...appServiceName };

    if (selectedItemsData.length === 0) {
      updatedServicePrices[itemId] = 0;
      updatedServiceUnitName[itemId] = 0;
      updatedServiceMinPrices[itemId] = 0;
      updatedServiceMaxPrices[itemId] = 0;
      updatedAppServiceName[itemId] = "";
      updatedAppServiceName[itemId] = "";
      updatedServiceCounts[itemId] = 0;
      updatedServiceCountsLength[itemId] = 0;
      updatedServiceCountsWidth[itemId] = 0;
      updatedServiceCountsKG[itemId] = 0;
      updatedServiceGarmentCountsItem[itemId] = 0;
    } else {
      const selectedItem = selectedItemsData.find((item) => item.id === itemId);
      updatedServicePrices[itemId] = selectedItem ? selectedItem.amount : 0;
      updatedServiceUnitName[itemId] = selectedItem
        ? selectedItem.serviceUnit
        : "";
      updatedServiceMinPrices[itemId] = selectedItem
        ? selectedItem.brandAppService.minAmount
        : 0;
      updatedServiceMaxPrices[itemId] = selectedItem
        ? selectedItem.brandAppService.maxAmount
        : 0;
      updatedAppServiceName[itemId] = selectedItem
        ? selectedItem.brandAppService.appService.name
        : "";
      updatedServiceCounts[itemId] = selectedItem ? 1 : 1;
      updatedServiceCountsLength[itemId] = selectedItem ? 0.1 : 0.1;
      updatedServiceCountsWidth[itemId] = selectedItem ? 0.1 : 0.1;
      updatedServiceCountsKG[itemId] = selectedItem ? 0.1 : 0.1;
      updatedServiceGarmentCountsItem[itemId] = selectedItem ? 1 : 1;
    }

    setServicePrices(updatedServicePrices);
    setServiceUnitName(updatedServiceUnitName);
    setServiceActualPrices(updatedServicePrices);
    setServiceMinPrices(updatedServiceMinPrices);
    setServiceMaxPrices(updatedServiceMaxPrices);
    setServiceCounts(updatedServiceCounts);
    setServiceCountsLength(updatedServiceCountsLength);
    setServiceCountsWidth(updatedServiceCountsWidth);
    setServiceCountsKG(updatedServiceCountsKG);
    setServiceGarmentCountsItem(updatedServiceGarmentCountsItem);
    setAppServiceName(updatedAppServiceName);
  };

  useEffect(() => {
    if (selectedGarment) {
      const {
        garment: { name, code, description, qrCodeCount },
        category: { name: categoryName },
        id,
      } = selectedGarment;

      setPriceListId(id);
      setGarmentName(name);
      setDescription(description);
      // setServiceUnit('Qty');
      setAmount(80);
      setQrCodeCount(qrCodeCount);
      // setPriceValue(200);
      setCategoryName(categoryName);
      // setServiceName('DRYCLEAN');
    }
  }, [selectedGarment]);

  const handleAliasChange = (text) => {
    if (text === "" || /^[a-zA-Z\s]*$/.test(text)) {
      setAliasValue(text);
      setAliasError("");
    } else {
      setAliasError("Only alphabets allowed");
    }
  };

  const handleGarmentRemarkChange = (text) => {
    setGarmentRemarkValue(text);
  };
  const [focusedField, setFocusedField] = useState("");

  const handleFocus = (field) => {
    setFocusedField(field);
  };

  const handleBlur = () => {
    setFocusedField("");
  };

  const [focusedDropdown, setFocusedDropdown] = useState("");

  const handleDropdownFocus = (field) => {
    setFocusedDropdown(field);
  };

  const handleDropdownBlur = () => {
    setFocusedDropdown("");
  };

  useEffect(() => {
    if (modalVisible) {
      // Set a timeout to close the modal after 2000 milliseconds (2 seconds)
      const timeoutId = setTimeout(() => {
        onClose(); // Call the onClose callback
        setModalVisible(false); // Close the modal by updating state
      }, 500);

      // Clear the timeout if the component unmounts or modalVisible changes
      return () => {
        clearTimeout(timeoutId);
      };
    }
  }, [modalVisible, onClose]);

  const [selectedServicesItem, setSelectedServicesItem] = useState([]);

  const remove = (itemId) => {
    // Set isSelect to false for the corresponding item in servicesData
    const updatedServicesData = servicesData.map((item) => {
      if (item.id === itemId) {
        return { ...item, isSelect: false };
      }
      return item;
    });
    setServicesData(updatedServicesData);

    const selectedItemsData = selectedServicesItem.filter(
      (item) => item.id !== itemId
    );
    setSelectedServicesItem(selectedItemsData);

    // Remove entries related to the itemId from the state variables
    const updatedServicePrices = { ...servicePrices };
    delete updatedServicePrices[itemId];

    const updatedServiceUnitName = { ...serviceUnitName };
    delete updatedServiceUnitName[itemId];

    const updatedServiceMinPrices = { ...serviceMinPrices };
    delete updatedServiceMinPrices[itemId];

    const updatedServiceMaxPrices = { ...serviceMaxPrices };
    delete updatedServiceMaxPrices[itemId];

    const updatedServiceCounts = { ...serviceCounts };
    delete updatedServiceCounts[itemId];

    const updatedServiceGarmentCountsItem = { ...serviceGarmentCountsItem };
    delete updatedServiceGarmentCountsItem[itemId];

    const updatedServiceCountsLength = { ...serviceCountsLength };
    delete updatedServiceCountsLength[itemId];

    const updatedServiceCountsWidth = { ...serviceCountsWidth };
    delete updatedServiceCountsWidth[itemId];

    const updatedServiceCountsKG = { ...serviceCountsKG };
    delete updatedServiceCountsKG[itemId];

    const updatedAppServiceName = { ...appServiceName };
    delete updatedAppServiceName[itemId];

    // Update the state with the modified variables
    setServicePrices(updatedServicePrices);
    setServiceUnitName(updatedServiceUnitName);
    setServiceActualPrices(updatedServicePrices);
    setServiceMinPrices(updatedServiceMinPrices);
    setServiceMaxPrices(updatedServiceMaxPrices);
    setServiceCounts(updatedServiceCounts);
    setServiceGarmentCountsItem(updatedServiceGarmentCountsItem);
    setServiceCountsLength(updatedServiceCountsLength);
    setServiceCountsWidth(updatedServiceCountsWidth);
    setServiceCountsKG(updatedServiceCountsKG);
    setAppServiceName(updatedAppServiceName);

    setKGError("");
    setQuantityError("");
    setIsGarmentButtonPressed(false);
  };

  const handlePriceChange = (text, itemId) => {

    if (!isRoundOffMode && text === ".") {
      setServicePrices((prevServicePrices) => ({
        ...prevServicePrices,
        [itemId]: ".", // Set the value to an empty string
      }));
      return;
    }

    if (text === "") {
      // Handle clearing the input field
      setServicePrices((prevServicePrices) => ({
        ...prevServicePrices,
        [itemId]: "", // Set the value to an empty string
      }));
      setIsGarmentButtonPressed(true);
      setPriceEmptyError("Price/ Pc can not be empty");
    } else {
      if (!inputRegex.test(text)) return;
      const newPriceValue = parseInt(text);

      const finalValue = isRoundOffMode ? String(Math.round(newPriceValue)) : text;

      if (!isNaN(newPriceValue)) {
        setServicePrices((prevServicePrices) => ({
          ...prevServicePrices,
          [itemId]: finalValue,
        }));
        setIsGarmentButtonPressed(false);
        setPriceEmptyError("");
      } else {
        // Handle invalid input
      }
    }
    validateInputs();
  };

  const handleQuantityChange = (text, itemId) => {
    if (text === "") {
      // Handle clearing the input field
      setServiceCounts((prevServiceCounts) => ({
        ...prevServiceCounts,
        [itemId]: "", // Set the value to an empty string
      }));
      setQuantityError("Quantity Not Be Zero or Empty");
      setIsGarmentButtonPressed(true);
    } else if (text > garmentMaxProcessCount) {
      // Handle clearing the input field
      setServiceCounts((prevServiceCounts) => ({
        ...prevServiceCounts,
        [itemId]: "", // Set the value to an empty string
      }));
      setQuantityError(
        "Quantity Not Be Greater Than " + garmentMaxProcessCount
      );
      setIsGarmentButtonPressed(true);
    } else {
      const newQuantity = parseInt(text);
      if (isNaN(newQuantity) || newQuantity === 0) {
        setQuantityError("Quantity must be a non-zero number");
        setIsGarmentButtonPressed(true);
      } else {
        setServiceCounts((prevServiceCounts) => ({
          ...prevServiceCounts,
          [itemId]: newQuantity,
        }));
        setQuantityError("");
        setIsGarmentButtonPressed(false);
      }
    }
  };

  const handleGarmentItemChange = (text, itemId) => {
    if (text === "") {
      // Handle clearing the input field
      setServiceGarmentCountsItem((prevServiceGarmentCountsItem) => ({
        ...prevServiceGarmentCountsItem,
        [itemId]: "", // Set the value to an empty string
      }));
      setItemGarmentCountError("Garment Count Can Not Be Zero or Empty");
      setIsGarmentButtonPressed(true);
    } else if (text > garmentMaxProcessCount) {
      // Handle clearing the input field
      setServiceGarmentCountsItem((prevServiceGarmentCountsItem) => ({
        ...prevServiceGarmentCountsItem,
        [itemId]: "", // Set the value to an empty string
      }));
      setItemGarmentCountError(
        "Garment Count Can Not Be Greater Than " + garmentMaxProcessCount
      );
      setIsGarmentButtonPressed(true);
    } else {
      const newQuantity = parseInt(text);
      if (isNaN(newQuantity) || newQuantity === 0) {
        // Handle invalid input (zero or non-numeric)
        setItemGarmentCountError("Garment Count must be a non-zero number");
        setIsGarmentButtonPressed(true);
      } else {
        // Valid input
        setServiceGarmentCountsItem((prevServiceGarmentCountsItem) => ({
          ...prevServiceGarmentCountsItem,
          [itemId]: newQuantity,
        }));
        setItemGarmentCountError("");
        setIsGarmentButtonPressed(false);
      }
    }
  };

  const handleKGChange = (text, itemId) => {
    if (text === "" || text == 0) {
      // Handle clearing the input field
      setServiceCountsKG((prevServiceCountsKG) => ({
        ...prevServiceCountsKG,
        [itemId]: "", // Set the value to an empty string
      }));
      setKGError("KG input can not be empty");
      setIsGarmentButtonPressed(true);
    } else {
      // Allow only valid numeric input including leading zeros and decimals
      const newKG = text;
      setServiceCountsKG((prevServiceCountsKG) => ({
        ...prevServiceCountsKG,
        [itemId]: newKG,
      }));
      setKGError("");
      setIsGarmentButtonPressed(false);
      if (!isNaN(newKG)) {
        setKGError("");
      } else {
        // Handle invalid input
        setIsGarmentButtonPressed(true);
        setKGError("Please Enter Correct KG Input");
      }
    }
  };

  const handleLengthChange = (text, itemId) => {
    if (text === "" || text == 0) {
      // Handle clearing the input field
      setServiceCountsLength((prevServiceCountsLength) => ({
        ...prevServiceCountsLength,
        [itemId]: "", // Set the value to an empty string
      }));
      setLengthError("Length Input can not be empty");
      setIsGarmentButtonPressed(true);
    } else {
      const newLength = text;
      setServiceCountsLength((prevServiceCountsLength) => ({
        ...prevServiceCountsLength,
        [itemId]: newLength,
      }));
      setLengthError("");
      setIsGarmentButtonPressed(false);
      if (!isNaN(newLength)) {
        setLengthError("");
      } else {
        // Handle invalid input
        setIsGarmentButtonPressed(true);
        setLengthError("Please Enter Correct Length Input");
      }
    }
  };

  const handleWidthChange = (text, itemId) => {
    if (text === "" || text == 0) {
      // Handle clearing the input field
      setServiceCountsWidth((prevServiceCountsWidth) => ({
        ...prevServiceCountsWidth,
        [itemId]: "", // Set the value to an empty string
      }));
      setWidthError("Width input can not be empty");
      setIsGarmentButtonPressed(true);
    } else {
      const newWidth = text;
      setServiceCountsWidth((prevServiceCountsWidth) => ({
        ...prevServiceCountsWidth,
        [itemId]: newWidth,
      }));
      setWidthError("");
      setIsGarmentButtonPressed(false);
      if (!isNaN(newWidth)) {
        setWidthError("");
      } else {
        // Handle invalid input
        setIsGarmentButtonPressed(true);
        setWidthError("Please Enter Correct Width Input");
      }
    }
  };

  // Define a function to handle quantity increment
  const incrementQuantity = (itemId) => {
    setServiceCounts((prevServiceCounts) => {
      const currentCount = prevServiceCounts[itemId] || 0;
      if (currentCount >= garmentMaxProcessCount) {
        return prevServiceCounts;
      }
      return {
        ...prevServiceCounts,
        [itemId]: prevServiceCounts[itemId] + 1, // Increment the value by 1
      };
    });
  };

  // Define a function to handle quantity decrement
  const decrementQuantity = (itemId) => {
    if (serviceCounts[itemId] > 1) {
      setServiceCounts((prevServiceCounts) => ({
        ...prevServiceCounts,
        [itemId]: prevServiceCounts[itemId] - 1, // Decrement the value by 1, but not below 1
      }));
    }
  };

  const serviceCountsArray2 = Object.values(serviceCounts);
  const serviceGarmentCountsArray2 = Object.values(serviceGarmentCountsItem);
  const serviceGarmentCountsKeys = Object.keys(serviceGarmentCountsItem);

  useEffect(() => {
    if (
      (serviceCountsArray2.length === 1 && serviceCountsArray2[0] > 1) ||
      serviceGarmentCountsArray2[0] > 1
    ) {
      setHandleServiceSelection(true);
    } else {
      setHandleServiceSelection(false);
    }

    if (serviceCountsArray2.length > 1) {
      setHandleInputDisable(true);
    } else {
      setHandleInputDisable(false);
    }
    validateInputs();
  }, [serviceCountsArray2, serviceGarmentCountsKeys]);

  const calculateTotal = () => {
    const totalPrice = {};
    const totalSqmtFt = {};
    let sumTotalCount = 0;
    let sumTotalPrice = 0;

    for (const serviceId in servicePrices) {
      const price = servicePrices[serviceId];
      const count = serviceCounts[serviceId];
      // const countSqMtrFt =
      //   Math.ceil(serviceCountsLength[serviceId].toFixed(2)) *
      //   Math.ceil(serviceCountsWidth[serviceId].toFixed(2));
      // const countSqMtrFt =
      //   serviceCountsLength[serviceId].toFixed(2) *
      //   serviceCountsWidth[serviceId].toFixed(2);
      const countSqMtrFt =
        serviceCountsLength[serviceId] * serviceCountsWidth[serviceId];
      // const countKG = serviceCountsKG[serviceId].toFixed(2);
      const countKG = serviceCountsKG[serviceId];
      const garmentCountKG = serviceGarmentCountsItem[serviceId];
      totalPrice[serviceId] = Number(
        price *
          (serviceUnitName[serviceId] === "Qty"
            ? count
            : serviceUnitName[serviceId] === "Kg"
            ? countKG
            : // ?  garmentCountKG
              countSqMtrFt)
      );
      totalSqmtFt[serviceId] =
        serviceUnitName[serviceId] === "Qty"
          ? count
          : serviceUnitName[serviceId] === "Kg"
          ? // ? Math.ceil(countKG)
            garmentCountKG
          : countSqMtrFt;
      BookingType === "PackageBooking"
        ? (sumTotalCount += count)
        : (sumTotalCount +=
            serviceUnitName[serviceId] === "Qty"
              ? count
              : serviceUnitName[serviceId] === "Kg"
              ? // ? Math.ceil(countKG)
                garmentCountKG
              : garmentCountKG);

      sumTotalPrice += totalPrice[serviceId];
    }
    return { totalPrice, totalSqmtFt, sumTotalCount, sumTotalPrice };
  };

  const calculateAddonArray = (
    servicePrices,
    serviceUnitName,
    serviceCounts,
    serviceCountsLength,
    serviceCountsWidth,
    serviceCountsKG,
    serviceGarmentCountsItem,
    appServiceName
    // priceListId,
  ) => {
    const addOnArray = [];

    for (const serviceId in servicePrices) {
      if (servicePrices.hasOwnProperty(serviceId)) {
        const priceListId = serviceId;
        const offerPrice = Number(Number(servicePrices[serviceId]).toFixed(enabledAmountRoundOff));
        // const countSqMtrFt =
        //   serviceCountsLength[serviceId].toFixed(2) *
        //   serviceCountsWidth[serviceId].toFixed(2);
        let count = 0;
        let countGram = 0;
        let totalPrice = 0;
        let addOnQrCount = 0;

        if (serviceUnitName[serviceId] === "Qty") {
          count = serviceCounts[serviceId];
          // totalPrice = Number(offerPrice).toFixed(enabledAmountRoundOff) * count;
          totalPrice = Number(
            (
              Number(offerPrice || 0)?.toFixed(enabledAmountRoundOff) *
              Number(count || 0)?.toFixed(enabledAmountRoundOff)
            ).toFixed(enabledAmountRoundOff)
          );

          addOnQrCount = count * qrCodeCount;
        } else if (serviceUnitName[serviceId] === "Kg") {
          const value = serviceCountsKG[serviceId];
          count = Math.floor(value);
          countGram = parseFloat((value - count).toFixed(2));
          // totalPrice = Number(Number(offerPrice).toFixed(enabledAmountRoundOff) * value);

          totalPrice = Number(
            (
              Number(offerPrice || 0)?.toFixed(enabledAmountRoundOff) *
              Number(value || 0)?.toFixed(enabledAmountRoundOff)
            ).toFixed(enabledAmountRoundOff)
          );

          if (BookingType === "PackageBooking") {
            addOnQrCount = serviceCounts[serviceId] * qrCodeCount;
          } else {
            addOnQrCount = serviceGarmentCountsItem[serviceId] * qrCodeCount;
          }
        } else {
          // const value =
          //   serviceCountsLength[serviceId].toFixed(2) *
          //   serviceCountsWidth[serviceId].toFixed(2);
          const value =
            serviceCountsLength[serviceId] * serviceCountsWidth[serviceId];
          count = Math.floor(value);
          countGram = parseFloat((value - count).toFixed(2));
          // totalPrice = Number(Number(offerPrice).toFixed(enabledAmountRoundOff) * value);
          totalPrice = Number(
            (
              Number(offerPrice || 0)?.toFixed(enabledAmountRoundOff) *
              Number(value || 0)?.toFixed(enabledAmountRoundOff)
            ).toFixed(enabledAmountRoundOff)
          );          

          // addOnQrCount = countSqMtrFt * qrCodeCount;
          if (BookingType === "PackageBooking") {
            addOnQrCount = serviceCounts[serviceId] * qrCodeCount;
          } else {
            addOnQrCount = serviceGarmentCountsItem[serviceId] * qrCodeCount;
          }
        }
        // const count =
        //   serviceUnitName[serviceId] === 'Qty'
        //     ? serviceCounts[serviceId]
        //     : serviceUnitName[serviceId] === 'Kg'
        //     ? Math.floor(serviceCountsKG[serviceId])
        //     : // ? Math.ceil(serviceGarmentCountsItem[serviceId])
        //       Math.ceil(serviceCountsLength[serviceId]) *
        //       Math.ceil(serviceCountsWidth[serviceId]);
        // const countGram =
        //   serviceUnitName[serviceId] === 'Qty'
        //     ? 0
        //     : serviceUnitName[serviceId] === 'Kg'
        //     ? Math.ceil(serviceCountsKG[serviceId])
        //     : // ? Math.ceil(serviceGarmentCountsItem[serviceId])
        //       Math.ceil(serviceCountsLength[serviceId]) *
        //       Math.ceil(serviceCountsWidth[serviceId]);
        const serviceName = appServiceName[serviceId];
        const serviceUnit = serviceUnitName[serviceId];

        const remarks = ""; // Modify this part based on your actual data.

        addOnArray.push({
          priceListId,
          offerPrice,
          count,
          countGram,
          serviceName,
          serviceUnit,
          totalPrice,
          remarks,
          addOnQrCount,
        });
      }
    }

    return addOnArray;
  };

  // Calculate the total price when the component initializes or whenever services change
  const [totalPrice, setTotalPrice] = useState(calculateTotal());

  const [addonArrayFun, setAddonArrayFun] = useState(
    calculateAddonArray(
      servicePrices,
      serviceUnitName,
      serviceCounts,
      serviceCountsLength,
      serviceCountsWidth,
      serviceCountsKG,
      serviceGarmentCountsItem,
      appServiceName
    )
  );
  useEffect(() => {
    // Update the total price whenever servicePrices or serviceCounts change
    setTotalPrice(calculateTotal());
    setAddonArrayFun(
      calculateAddonArray(
        servicePrices,
        serviceUnitName,
        serviceCounts,
        serviceCountsLength,
        serviceCountsWidth,
        serviceCountsKG,
        serviceGarmentCountsItem,
        appServiceName
        // priceListId,
      )
    );
  }, [
    servicePrices,
    serviceUnitName,
    serviceCounts,
    serviceCountsKG,
    serviceGarmentCountsItem,
    serviceCountsLength,
    serviceCountsWidth,
    appServiceName,
  ]);

  const validateInputs = () => {
    let isError = true;
    setPriceError("");
    if (
      BookingType === "GeneralBooking" &&
      servicesData[0]?.price.minMaxCheckEnabled
    ) {
      for (const serviceId in servicePrices) {
        const price = servicePrices[serviceId];
        if (price < serviceMinPrices[serviceId]) {
          setPriceError(
            `Price/ Pc can not be less than ${serviceMinPrices[serviceId]}`
          );
          isError = false;
        } else if (price > serviceMaxPrices[serviceId]) {
          setPriceError(
            `Price/ Pc can not be greater than ${serviceMaxPrices[serviceId]}`
          );
          isError = false;
        }
      }
    } else {
      isError = true;
    }
    return isError;
  };

  const handleAddGarment = (event, handlingType) => {
    // Check if the button has already been pressed

    event.preventDefault();
    // Reset previous error messages
    setServiceError("");
    setPriceError("");

    // Check if a service is selected
    if (BookingType === "GeneralBooking") {
      if (selectedServicesItem.length === 0) {
        setServiceError("Please select a service.");
        return;
      }
    }
    if (validateInputs()) {
      if (!isGarmentButtonPressed) {
        // Set the state to indicate that the button has been pressed
        setIsGarmentButtonPressed(true);
        setIsGarmentViewDisable(true);
        const garment = {
          storeCustomerId: storeCustomerId,
          storeUserId: storeUserId,
          offerPrice: amount,
          totalPrice: 1,
          itemGarmentCount:
            qrCodeCount * (handleInputDisable ? 1 : totalPrice.sumTotalCount),
          garmentQrCount: qrCodeCount,
          garmentName: garmentName,
          garmentCategoryId: garmentCategoryId,
          garmentAlias: aliasValue?.toUpperCase(),
          selectedPriceId: selectedPriceId,
          remarks: [
            garmentRemarkValue,
            ...selectedRemarksArray,
            ...selectedRemarksArrayOne,
            ...selectedRemarksArrayTwo,
            ...selectedRemarksArrayThree,
            ...selectedRemarksArrayColor,
          ]
            .filter(Boolean) // Remove any undefined, null, or empty strings
            .join(", "),
          categoryName: categoryName,
          garmentPack: packingTypeValue.name,
          bookingType: BookingType,
          addOn: addonArrayFun,
        };

        const addMoreGarment = {
          // id: bookingOrderId
          totalPrice: 1,
          offerPrice: amount,
          itemGarmentCount:
            qrCodeCount * (handleInputDisable ? 1 : totalPrice.sumTotalCount),
          remarks: [
            garmentRemarkValue,
            ...selectedRemarksArray,
            ...selectedRemarksArrayOne,
            ...selectedRemarksArrayTwo,
            ...selectedRemarksArrayThree,
            ...selectedRemarksArrayColor,
          ]
            .filter(Boolean) // Remove any undefined, null, or empty strings
            .join(", "),
          garmentPack: packingTypeValue.name,
          garmentAlias: aliasValue?.toUpperCase(),
          selectedPriceId: selectedPriceId,
          garmentName: garmentName,
          garmentCategoryId: garmentCategoryId,
          garmentQrCount: qrCodeCount,
          garmentCategory: categoryName,
          addOns: addonArrayFun,
          bookingType: BookingType,
          editBy: storeUserId,
          editByUserName:
            userProfileData?.firstName + userProfileData?.lastName,
        };

        if (bookingOrderId && B2BModel) {
          addMoreItemToOrderB2BOrder(
            storeCustomerId,
            storeId,
            bookingOrderId,
            addMoreGarment
          )
            .then((response) => {
              if (!response.data.error) {
                const Res = response.data;
                // Call the onAddToCart callback to add the garment to the cart
                if (handlingType === "continue") {
                  setModalVisibleContinue(true);
                  setServicesData(servicesDataFixed); // services list
                  setSelectedServicesItem([]); // selected service garment info
                  setAliasValue("");
                  setPackingTypeValue("");
                  setGarmentRemarksTypeValue("");
                  setGarmentRemarksValueData("");
                  setGarmentRemarkValue("");
                  setSelectedRemarksArray([]);
                  setSelectedRemarksArrayOne([]);
                  setSelectedRemarksArrayTwo([]);
                  setSelectedRemarksArrayThree([]);
                  setSelectedRemarksArrayColor([]);
                  setServicePrices(0);
                  setServiceUnitName(0);
                  setServiceActualPrices(0);
                  setServiceMinPrices(0);
                  setServiceMaxPrices(0);
                  setServiceCounts(0);
                  setServiceCountsLength(0);
                  setServiceCountsWidth(0);
                  setServiceCountsKG(0);
                  setServiceGarmentCountsItem(0);
                  setAppServiceName(0);
                  setAttributeOne(
                    storeGarmentRemarksData[keysArrayRemarksData[0]]?.map(
                      (item) => item.remark
                    )
                  );
                  setAttributeTwo(
                    storeGarmentRemarksData[keysArrayRemarksData[1]]?.map(
                      (item) => item.remark
                    )
                  );
                  setAttributeThree(
                    storeGarmentRemarksData[keysArrayRemarksData[2]]?.map(
                      (item) => item.remark
                    )
                  );
                  setAttributeColor(
                    FixedColorAttribute?.map((item) => item.remark)
                  );
                } else {
                  setModalVisible(true);
                  if (Res) {
                    navigate("/B2BOrdersGarmentInfo", {
                      state: {
                        bookingOrderId: bookingOrderId,
                        storeCustomerId: storeCustomerId,
                      },
                    });
                  }
                }
                setIsGarmentButtonPressed(false);
                setIsGarmentViewDisable(false);
                // if (Res) {
                //   navigate("/OrdersGarmentInfo", {state: {
                //     bookingOrderId: bookingOrderId,
                //     storeCustomerId: storeCustomerId,
                //   }});
                // }
              }
            })
            .catch((err) => {
              console.error("Error:", err);
            });
        } else if (bookingOrderId) {
          addMoreItemToOrder(
            storeCustomerId,
            storeId,
            bookingOrderId,
            addMoreGarment
          )
            .then((response) => {
              if (!response.data.error) {
                const Res = response.data;
                // Call the onAddToCart callback to add the garment to the cart
                if (handlingType === "continue") {
                  setModalVisibleContinue(true);
                  setServicesData(servicesDataFixed); // services list
                  setSelectedServicesItem([]); // selected service garment info
                  setAliasValue("");
                  setPackingTypeValue("");
                  setGarmentRemarksTypeValue("");
                  setGarmentRemarksValueData("");
                  setGarmentRemarkValue("");
                  setSelectedRemarksArray([]);
                  setSelectedRemarksArrayOne([]);
                  setSelectedRemarksArrayTwo([]);
                  setSelectedRemarksArrayThree([]);
                  setSelectedRemarksArrayColor([]);
                  setServicePrices(0);
                  setServiceUnitName(0);
                  setServiceActualPrices(0);
                  setServiceMinPrices(0);
                  setServiceMaxPrices(0);
                  setServiceCounts(0);
                  setServiceCountsLength(0);
                  setServiceCountsWidth(0);
                  setServiceCountsKG(0);
                  setServiceGarmentCountsItem(0);
                  setAppServiceName(0);
                  setAttributeOne(
                    storeGarmentRemarksData[keysArrayRemarksData[0]]?.map(
                      (item) => item.remark
                    )
                  );
                  setAttributeTwo(
                    storeGarmentRemarksData[keysArrayRemarksData[1]]?.map(
                      (item) => item.remark
                    )
                  );
                  setAttributeThree(
                    storeGarmentRemarksData[keysArrayRemarksData[2]]?.map(
                      (item) => item.remark
                    )
                  );
                  setAttributeColor(
                    FixedColorAttribute?.map((item) => item.remark)
                  );
                } else {
                  setModalVisible(true);
                  if (Res) {
                    navigate("/OrdersGarmentInfo", {
                      state: {
                        bookingOrderId: bookingOrderId,
                        storeCustomerId: storeCustomerId,
                      },
                    });
                  }
                }
                setIsGarmentButtonPressed(false);
                setIsGarmentViewDisable(false);
                // if (Res) {
                //   navigate("/OrdersGarmentInfo", {state: {
                //     bookingOrderId: bookingOrderId,
                //     storeCustomerId: storeCustomerId,
                //   }});
                // }
              }
            })
            .catch((err) => {
              console.error("Error:", err);
            });
        } else {
          addItemToCart(storeCustomerId, storeId, garment)
            .then((response) => {
              if (!response.data.error) {
                const Res = response.data;

                // Call the onAddToCart callback to add the garment to the cart
                if (Res.status === true) {
                  if (handlingType === "continue") {
                    setModalVisibleContinue(true);
                    setServicesData(servicesDataFixed); // services list
                    setSelectedServicesItem([]); // selected service garment info
                    setAliasValue("");
                    setPackingTypeValue("");
                    setGarmentRemarksTypeValue("");
                    setGarmentRemarksValueData("");
                    setGarmentRemarkValue("");
                    setSelectedRemarksArray([]);
                    setSelectedRemarksArrayOne([]);
                    setSelectedRemarksArrayTwo([]);
                    setSelectedRemarksArrayThree([]);
                    setSelectedRemarksArrayColor([]);
                    setServicePrices(0);
                    setServiceUnitName(0);
                    setServiceActualPrices(0);
                    setServiceMinPrices(0);
                    setServiceMaxPrices(0);
                    setServiceCounts(0);
                    setServiceCountsLength(0);
                    setServiceCountsWidth(0);
                    setServiceCountsKG(0);
                    setServiceGarmentCountsItem(0);
                    setAppServiceName(0);
                    setAttributeOne(
                      storeGarmentRemarksData[keysArrayRemarksData[0]]?.map(
                        (item) => item.remark
                      )
                    );
                    setAttributeTwo(
                      storeGarmentRemarksData[keysArrayRemarksData[1]]?.map(
                        (item) => item.remark
                      )
                    );
                    setAttributeThree(
                      storeGarmentRemarksData[keysArrayRemarksData[2]]?.map(
                        (item) => item.remark
                      )
                    );
                    setAttributeColor(
                      FixedColorAttribute?.map((item) => item.remark)
                    );
                  } else {
                    setModalVisible(true);
                  }
                  setModalStatus("success");
                  onAddToCart(garment);
                } else {
                  if (handlingType === "continue") {
                    setModalVisibleContinue(true);
                    setServicesData(servicesDataFixed);
                    setSelectedServicesItem([]);
                    setAliasValue("");
                    setPackingTypeValue("");
                    setGarmentRemarksTypeValue("");
                    setGarmentRemarksValueData("");
                    setGarmentRemarkValue("");
                    setSelectedRemarksArray([]);
                    setSelectedRemarksArrayOne([]);
                    setSelectedRemarksArrayTwo([]);
                    setSelectedRemarksArrayThree([]);
                    setSelectedRemarksArrayColor([]);
                    setServicePrices(0);
                    setServiceUnitName(0);
                    setServiceActualPrices(0);
                    setServiceMinPrices(0);
                    setServiceMaxPrices(0);
                    setServiceCounts(0);
                    setServiceCountsLength(0);
                    setServiceCountsWidth(0);
                    setServiceCountsKG(0);
                    setServiceGarmentCountsItem(0);
                    setAppServiceName(0);
                    setAttributeOne(
                      storeGarmentRemarksData[keysArrayRemarksData[0]]?.map(
                        (item) => item.remark
                      )
                    );
                    setAttributeTwo(
                      storeGarmentRemarksData[keysArrayRemarksData[1]]?.map(
                        (item) => item.remark
                      )
                    );
                    setAttributeThree(
                      storeGarmentRemarksData[keysArrayRemarksData[2]]?.map(
                        (item) => item.remark
                      )
                    );
                    setAttributeColor(
                      FixedColorAttribute?.map((item) => item.remark)
                    );
                  } else {
                    setModalVisible(true);
                  }
                  setModalStatus("not Success");
                }
                setIsGarmentButtonPressed(false);
                setIsGarmentViewDisable(false);
              }
            })
            .catch((err) => {
              console.error("Error:", err);
            });
        }
      }
    }
  };

  const [servicesLoaded, setServicesLoaded] = useState(false);

  useEffect(() => {
    if (servicesData.length > 0 && !servicesLoaded) {
      // Automatically select the first service
      if (servicesData.length === 1) {
        handleServiceToggle(servicesData[0].id);
      } else if (enabledAutoSelectAppService) {
        handleServiceToggle(servicesData[0].id);
      }
      setServicesLoaded(true);
    }
  }, [servicesData, servicesLoaded]);


  const [selectedColor, setSelectedColor] = useState(null);
 

  const renderGarmentRemarksDataOne = () => {
    return selectedRemarksArrayOne?.map((item, index) => (
      <div
        className="my-2"
        style={{
          flex: 1,
          borderRadius: 5,
          backgroundImage:
            "radial-gradient(circle at left top, #2E3192, #ffffff)",
        }}
      >
        <div className="flex flex-1 flex-row justify-content-between py-2">
          <div className="flex-1 ml-2">
            <p className="text-md text-white font-semibold">{item}</p>
          </div>
          <div
            className="px-3 cursor-pointer"
            style={{
              backgroundColor: "red",
              alignSelf: "center",
              borderRadius: 5,
            }}
            onClick={() => removeRemarksOne(item)}
          >
            <div>
              <p className="text-lg font-semibold text-white text-center">X</p>
            </div>
          </div>
        </div>
      </div>
    ));
  };

  const renderGarmentRemarksDataTwo = () => {
    return selectedRemarksArrayTwo?.map((item, index) => (
      <div
        className="my-2"
        style={{
          flex: 1,
          borderRadius: 5,
          backgroundImage:
            "radial-gradient(circle at left top, #2E3192, #ffffff)",
        }}
      >
        <div className="flex flex-1 flex-row justify-content-between py-2">
          <div className="flex-1 ml-2">
            <p className="text-md text-white font-semibold">{item}</p>
          </div>
          <div
            className="px-3 cursor-pointer"
            style={{
              backgroundColor: "red",
              alignSelf: "center",
              borderRadius: 5,
            }}
            onClick={() => removeRemarksTwo(item)}
          >
            <div>
              <p className="text-lg font-semibold text-white text-center">X</p>
            </div>
          </div>
        </div>
      </div>
    ));
  };

  const renderGarmentRemarksDataThree = () => {
    return selectedRemarksArrayThree?.map((item, index) => (
      <div
        className="my-2"
        style={{
          flex: 1,
          borderRadius: 5,
          backgroundImage:
            "radial-gradient(circle at left top, #2E3192, #ffffff)",
        }}
      >
        <div className="flex flex-1 flex-row justify-content-between py-2">
          <div className="flex-1 ml-2">
            <p className="text-md text-white font-semibold">{item}</p>
          </div>
          <div
            className="px-3 cursor-pointer"
            style={{
              backgroundColor: "red",
              alignSelf: "center",
              borderRadius: 5,
            }}
            onClick={() => removeRemarksThree(item)}
          >
            <div>
              <p className="text-lg font-semibold text-white text-center">X</p>
            </div>
          </div>
        </div>
      </div>
    ));
  };

  const renderGarmentRemarksData = () => {
    return selectedRemarksArray?.map((item, index) => (
      <div
        className="my-2"
        style={{
          flex: 1,
          borderRadius: 5,
          backgroundImage:
            "radial-gradient(circle at left top, #2E3192, #ffffff)",
        }}
      >
        <div className="flex flex-1 flex-row justify-content-between py-2">
          <div className="flex-1 ml-2">
            <p className="text-md text-white font-semibold">{item}</p>
          </div>
          <div
            className="px-3 cursor-pointer"
            style={{
              backgroundColor: "red",
              alignSelf: "center",
              borderRadius: 5,
            }}
            onClick={() => removeRemarks(item)}
          >
            <div>
              <p className="text-lg font-semibold text-white text-center">X</p>
            </div>
          </div>
        </div>
      </div>
    ));
  };

  const renderGarmentColorRemarksData = () => {
    return selectedRemarksArrayColor?.map((item, index) => (
      <div
        className="my-2"
        style={{
          flex: 1,
          borderRadius: 5,
          backgroundImage:
            "radial-gradient(circle at left top, #2E3192, #ffffff)",
        }}
      >
        <div className="flex flex-1 flex-row justify-content-between py-2">
          <div className="flex-1 ml-2">
            <p className="text-md text-white font-semibold">{item}</p>
          </div>
          <div
            className="px-3 cursor-pointer"
            style={{
              backgroundColor: "red",
              alignSelf: "center",
              borderRadius: 5,
            }}
            onClick={() => removeRemarksColor(item)}
          >
            <div>
              <p className="text-lg font-semibold text-white text-center">X</p>
            </div>
          </div>
        </div>
      </div>
    ));
  };

  const renderServicesCardItem = () => {
    return servicesData?.map((item, index) => (
      <div className="h-1rem mx-2 my-2">
        <div
          onClick={() =>
            handleServiceSelection ? "" : handleServiceToggle(item.id)
          }
          // disabled={handleServiceSelection}
          className="cursor-pointer"
        >
          <div>
            <div className="flex justify-content-center">
              <img
                // src={
                //   item.brandAppService.appService.logo
                //     ? `data:image/jpeg;base64,${item.brandAppService.appService.logo}`
                //     : "Laundy_App_Icons_Gifs/Book_New_Order/Dry_Cleaning_Active.png"
                // }
                src={
                  garmentServiceIcons[
                    item?.brandAppService?.appService?.imageId
                  ]
                    ? `data:image/jpeg;base64,${
                        garmentServiceIcons[
                          item?.brandAppService?.appService?.imageId
                        ]
                      }`
                    : "Laundy_App_Icons_Gifs/Book_New_Order/Dry_Cleaning_Active.png"
                }
                resizeMode="cover"
                style={{
                  alignSelf: "center", // to center an image
                  width: item.isSelect
                    ? height < 600
                      ? 65
                      : 75
                    : height < 600
                    ? 50
                    : 60,
                  height: item.isSelect
                    ? height < 600
                      ? 65
                      : 75
                    : height < 600
                    ? 50
                    : 60,
                }}
                alt="appIcons"
              />
            </div>
            <div className="mx-2 align-self-center my-2">
              <p
                className="text-md font-normal"
                style={{
                  color: item.isSelect ? "#008EFF" : "#75879B",
                  textAlign: "center",
                }}
              >
                {item.brandAppService.appService.name}
              </p>
            </div>
          </div>
        </div>
      </div>
    ));
  };

  const renderServiceInfoItem = () => {
    return selectedServicesItem?.map((item, index) => (
      <div className="mb-4">
        <div className="flex flex-row gap-3">
          <div
            className="ml-2 py-1 flex justify-content-center align-items-center cursor-pointer"
            style={{
              flex: 0.18,
              backgroundColor: "red",
              borderRadius: 5,
            }}
            onClick={() => remove(item.id)}
          >
            <p className="text-lg font-bold text-white">X</p>
          </div>
          <div
            className="ml-1 py-1 flex-1"
            style={{
              backgroundColor: "#6EA4F5",
              borderRadius: 5,
            }}
          >
            <div className="ml-4">
              <p className="text-lg font-bold text-white">
                {appServiceName[item.id]}{" "}
                {isNaN(totalPrice.totalPrice[item.id])
                  ? 0
                  : Number(totalPrice.totalPrice[item.id]?.toFixed(enabledAmountRoundOff))}
              </p>
            </div>
          </div>
        </div>

        {BookingType === "PackageBooking" ? (
          <div className="ml-2 bg-white border-round-xl shadow-4">
            <div className="flex flex-row">
              <div className="flex-1 mx-2 my-1">
                <div>
                  <p>Price</p>
                  <div className="border-round-xl shadow-2">
                    <InputText
                      style={{ width: "100%" }}
                      value={servicePrices[item.id].toString()}
                      onChange={(e) =>
                        handlePriceChange(e.target.value, item.id)
                      }
                      keyboardType="numeric"
                      disabled={true}
                    />
                  </div>
                </div>
              </div>
              <div className="flex-1 mx-2 my-1">
                <div className="flex flex-row justify-content-center align-items-center">
                  <div
                    onClick={() => decrementQuantity(item.id)}
                    className="justify-content-center align-items-center  shadow-4 mx-2 mt-4 cursor-pointer"
                    style={{
                      backgroundColor: "#2B70D7",
                      borderRadius: 50, // Make it circular (adjust the value as needed)
                      width: height < 600 ? 25 : 30, // Width of the button
                      height: height < 600 ? 25 : 30, // Height of the button
                    }}
                  >
                    <p className="text-lg font-bold text-white text-center">
                      -
                    </p>
                  </div>
                  <div>
                    <p>Quantity</p>
                    <div className="border-round-xl shadow-2">
                      <InputText
                        value={serviceCounts[item.id].toString()}
                        onChange={(e) =>
                          handleQuantityChange(e.target.value, item.id)
                        }
                        keyboardType="numeric"
                      />
                    </div>
                  </div>
                  <div
                    onClick={() => incrementQuantity(item.id)}
                    className="justify-content-center align-items-center  shadow-4 mx-2 mt-4 cursor-pointer"
                    style={{
                      backgroundColor: "#2B70D7",
                      borderRadius: 50, // Make it circular (adjust the value as needed)
                      width: height < 600 ? 25 : 30, // Width of the button
                      height: height < 600 ? 25 : 30, // Height of the button
                    }}
                  >
                    <p className="text-lg font-bold text-white text-center">
                      +
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="ml-2 bg-white border-round-xl shadow-4">
            {["Mtr", "SqFt"].includes(serviceUnitName[item.id]) && (
              <div className="flex flex-row">
                <React.Fragment>
                  <div className="flex-1 mx-2 my-1">
                    <div>
                      <div>
                        <p>Length</p>
                        <div className="border-round-xl shadow-2">
                          <InputText
                            style={{ width: "100%" }}
                            value={serviceCountsLength[item.id].toString()}
                            onChange={(e) =>
                              handleLengthChange(e.target.value, item.id)
                            }
                            keyboardType="numeric"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="flex-1 mx-2 my-1">
                    <div>
                      <div>
                        <p>Width</p>
                        <div className="border-round-xl shadow-2">
                          <InputText
                            style={{ width: "100%" }}
                            value={serviceCountsWidth[item.id].toString()}
                            onChange={(e) =>
                              handleWidthChange(e.target.value, item.id)
                            }
                            keyboardType="numeric"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </React.Fragment>
              </div>
            )}

            <div className="flex flex-row">
              <div className="flex-1 mx-2 my-1">
                <p>Price</p>
                <div className="border-round-xl shadow-2">
                  <InputText
                    style={{ width: "100%" }}
                    value={servicePrices[item.id].toString()}
                    onChange={(e) => handlePriceChange(e.target.value, item.id)}
                    keyboardType="numeric"
                    keyFilter={isRoundOffMode ? "int" : /[\d.]/}
                    disabled={!offerPriceEnabled ? true : false}
                  />
                </div>
              </div>

              <div className="flex-1 mx-2 my-1">
                {serviceUnitName[item.id] === "Qty" && (
                  <div className="flex flex-row justify-content-center align-items-center">
                    <div
                      onClick={() =>
                        handleInputDisable ? "" : decrementQuantity(item.id)
                      }
                      role="button"
                      className={`justify-content-center align-items-center shadow-4 mx-2 mt-4 cursor-pointer ${
                        handleInputDisable ? "disabled" : ""
                      }`}
                      style={{
                        backgroundColor: handleInputDisable
                          ? "#A9A9A9"
                          : "#2B70D7",
                        borderRadius: 50, // Make it circular (adjust the value as needed)
                        width: height < 600 ? 25 : 30, // Width of the button
                        height: height < 600 ? 25 : 30, // Height of the button
                        opacity:
                          handleInputDisable && item.serviceUnit === "Qty"
                            ? 0.6
                            : 1,
                        pointerEvents:
                          handleInputDisable && item.serviceUnit === "Qty"
                            ? "none"
                            : "auto",
                      }}
                    >
                      <p className="text-lg font-bold text-white text-center">
                        -
                      </p>
                    </div>
                    <div>
                      <div>Qty</div>
                      <div className="border-round-xl shadow-2">
                        <InputText
                          value={serviceCounts[item.id].toString()}
                          onChange={(e) =>
                            handleQuantityChange(e.target.value, item.id)
                          }
                          disabled={handleInputDisable}
                          keyboardType="numeric"
                        />
                      </div>
                    </div>
                    <div
                      onClick={() =>
                        handleInputDisable ? "" : incrementQuantity(item.id)
                      }
                      role="button"
                      className={`justify-content-center align-items-center shadow-4 mx-2 mt-4 cursor-pointer ${
                        handleInputDisable ? "disabled" : ""
                      }`}
                      style={{
                        backgroundColor: handleInputDisable
                          ? "#A9A9A9"
                          : "#2B70D7",
                        borderRadius: 50, // Make it circular (adjust the value as needed)
                        width: height < 600 ? 25 : 30, // Width of the button
                        height: height < 600 ? 25 : 30, // Height of the button
                        opacity:
                          handleInputDisable && item.serviceUnit === "Qty"
                            ? 0.6
                            : 1,
                        pointerEvents:
                          handleInputDisable && item.serviceUnit === "Qty"
                            ? "none"
                            : "auto",
                      }}
                    >
                      <p className="text-lg font-bold text-white text-center">
                        +
                      </p>
                    </div>
                  </div>
                )}

                {serviceUnitName[item.id] === "Kg" && (
                  <div className="flex flex-row justify-content-center align-items-center">
                    <div>
                      <p>KG</p>
                      <div className="border-round-xl shadow-2">
                        <InputText
                          style={{ width: "100%" }}
                          value={serviceCountsKG[item.id].toString()}
                          onChange={(e) =>
                            handleKGChange(e.target.value, item.id)
                          }
                          keyboardType="numeric"
                        />
                      </div>
                    </div>
                  </div>
                )}
                {["Mtr", "SqFt"].includes(serviceUnitName[item.id]) && (
                  <div>
                    <p>
                      {serviceUnitName[item.id] === "Mtr"
                        ? "Total Square Meter"
                        : "Total Square feet"}
                    </p>
                    <div className="border-round-xl shadow-2">
                      <InputText
                        style={{ width: "100%" }}
                        value={
                          isNaN(totalPrice?.totalSqmtFt[item.id])
                            ? "0.00"
                            : totalPrice.totalSqmtFt[item.id]
                                .toFixed(2)
                                .toString()
                        }
                        onChange={(e) =>
                          handlePriceChange(e.target.value, item.id)
                        }
                        keyboardType="numeric"
                        disabled={true}
                      />
                    </div>
                  </div>
                )}
              </div>
            </div>
            {["Mtr", "SqFt", "Kg"].includes(serviceUnitName[item.id]) && (
              <div className="flex flex-row">
                <div className="flex-1 mx-2 my-1">
                  <div>
                    <p>Garment Count</p>
                    <div className="border-round-xl shadow-2">
                      <InputText
                        style={{ width: "100%" }}
                        value={serviceGarmentCountsItem[item.id].toString()}
                        onChange={(e) =>
                          handleGarmentItemChange(e.target.value, item.id)
                        }
                        keyboardType="numeric"
                        disabled={handleInputDisable}
                      />
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    ));
  };

  const selectedTemplate = (option, props) => {
    if (option) {
      return (
        <div className="flex align-items-center">
          <div>{option}</div>
        </div>
      );
    }

    return <span>{props.placeholder}</span>;
  };

  const optionTemplate = (option) => {
    return (
      <div className="flex align-items-center">
        <div>{option}</div>
      </div>
    );
  };

  return (
    <div>
      <div>
        <div style={{ pointerEvents: isGarmentViewDisable ? "none" : "auto" }}>
          <div className="my-2">
            <p className="text-lg text-black-alpha-90 font-medium">
              Select Service
            </p>
          </div>
          <div
            className="flex h-8rem gap-4 pb-1 new-scroll-bar"
            style={{
              overflowX: "auto",
              // whiteSpace: "nowrap",
            }}
          >
            {renderServicesCardItem()}
          </div>
          <div>{serviceError !== "" && <p>{serviceError}</p>}</div>

          <div className="mr-1 my-1">
            {renderServiceInfoItem()}
            {priceError !== "" && (
              <p className="text-md font-normal" style={{ color: "red" }}>
                {priceError}
              </p>
            )}
            {priceEmptyError !== "" && (
              <p className="text-md font-normal" style={{ color: "red" }}>
                {priceEmptyError}
              </p>
            )}
            {itemGarmentCountError !== "" && (
              <p className="text-md font-normal" style={{ color: "red" }}>
                {itemGarmentCountError}
              </p>
            )}
            {quantityError !== "" && (
              <p className="text-md font-normal" style={{ color: "red" }}>
                {quantityError}
              </p>
            )}
            {kGError !== "" && (
              <p className="text-md font-normal" style={{ color: "red" }}>
                {kGError}
              </p>
            )}
            {lengthError !== "" && (
              <p className="text-md font-normal" style={{ color: "red" }}>
                {lengthError}
              </p>
            )}
            {widthError !== "" && (
              <p className="text-md font-normal" style={{ color: "red" }}>
                {widthError}
              </p>
            )}
          </div>

          <div className="flex-1 mx-2 mb-1 mt-3">
            <div className="border-round-xl shadow-2">
              <InputText
                style={{ width: "100%" }}
                id="Alias"
                value={aliasValue}
                onChange={(e) => handleAliasChange(e.target.value)}
                placeholder="Alias"
              />
            </div>
          </div>

          {aliasError !== "" && (
            <p className="text-md font-normal" style={{ color: "red" }}>
              {aliasError}
            </p>
          )}

          <div className="flex-1 mx-2 mb-1 mt-3">
            <div className="border-round-xl shadow-2">
              <Dropdown
                value={packingTypeValue}
                onChange={(e) => setPackingTypeValue(e.value)}
                options={packagingType}
                optionLabel="name"
                placeholder="Packing Type"
                className="w-full  bg-white-alpha-20  text-xl text-primary-50"
              />
            </div>
          </div>
          {enabledPreDefinedRemark && (
            <div>
              <div className="flex-1 flex-row">
                {keysArrayRemarksData.length >= 1 && (
                  <div className="mx-2 mb-1 mt-3" style={{ width: width / 3 }}>
                    <div className="border-round-xl shadow-2">
                      <Dropdown
                        value={garmentRemarksValueData}
                        onChange={(e) => handleRemarkSelectOne(e.value)}
                        options={attributeOne}
                        optionLabel="name"
                        placeholder={keysArrayRemarksData[0]}
                        filter
                        valueTemplate={selectedTemplate}
                        itemTemplate={optionTemplate}
                        className="w-full  bg-white-alpha-20 text-xl text-primary-50 garmentDropdown"
                      />
                    </div>
                  </div>
                )}
                {keysArrayRemarksData.length >= 2 && (
                  <div className="mx-2 mb-1 mt-3" style={{ width: width / 3 }}>
                    <div className="border-round-xl shadow-2 ">
                      <Dropdown
                        value={garmentRemarksValueData}
                        onChange={(e) => handleRemarkSelectTwo(e.value)}
                        options={attributeTwo}
                        optionLabel="name"
                        placeholder={keysArrayRemarksData[1]}
                        filter
                        valueTemplate={selectedTemplate}
                        itemTemplate={optionTemplate}
                        className="w-full  bg-white-alpha-20 text-xl text-primary-50 garmentDropdown"
                      />
                    </div>
                  </div>
                )}
                {keysArrayRemarksData.length >= 3 && (
                  <div className="mx-2 mb-1 mt-3" style={{ width: width / 3 }}>
                    <div className="border-round-xl shadow-2">
                      <Dropdown
                        value={garmentRemarksValueData}
                        onChange={(e) => handleRemarkSelectThree(e.value)}
                        options={attributeThree}
                        optionLabel="name"
                        placeholder={keysArrayRemarksData[2]}
                        filter
                        valueTemplate={selectedTemplate}
                        itemTemplate={optionTemplate}
                        className="w-full  bg-white-alpha-20 text-xl text-primary-50 garmentDropdown"
                      />
                    </div>
                  </div>
                )}
              </div>
              {keysArrayRemarksData.length > 3 && (
                <div className="flex-1 mx-2 mb-1 mt-3">
                  <div className="border-round-xl shadow-2">
                    <Dropdown
                      value={garmentRemarksTypeValue}
                      onChange={(e) => handleKeySelect(e.value)}
                      options={keysArrayRemarksData.slice(3)}
                      optionLabel="name"
                      placeholder="Other Attribute Type"
                      filter
                      valueTemplate={selectedTemplate}
                      itemTemplate={optionTemplate}
                      className="w-full  bg-white-alpha-20 text-xl text-primary-50"
                    />
                  </div>
                </div>
              )}
              {selectedGarmentRemarksTypeArray?.length > 0 && (
                <div className="flex-1 mx-2 mb-1 mt-3">
                  <div className="border-round-xl shadow-2">
                    <Dropdown
                      value={garmentRemarksValueData}
                      onChange={(e) => handleRemarkSelect(e.value)}
                      options={selectedGarmentRemarksTypeArray}
                      optionLabel="name"
                      placeholder="Other Attribute"
                      filter
                      valueTemplate={selectedTemplate}
                      itemTemplate={optionTemplate}
                      className="w-full  bg-white-alpha-20 text-xl text-primary-50"
                    />
                  </div>
                </div>
              )}
              {attributeColor?.length > 0 && (
                <div>
                  <p className="mx-2 mb-1 mt-3 text-md font-normal">Colors</p>
                  <div
                    style={{ display: "flex", gap: "15px", flexWrap: "wrap" }}
                    className="mx-2"
                  >
                    {attributeColor?.map((color, index) => (
                      <div 
                        title={color}
                        key={index}
                        onClick={() => handleRemarkColorSelect(color)}
                        style={{
                          width: "30px",
                          height: "30px",
                          borderRadius: "50px",
                          // fontSize: "10px",
                          backgroundColor: color.toLowerCase(),
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          color:
                            color.toLowerCase() === "white" ? "black" : "white",
                          fontWeight: "bold",
                          cursor: "pointer",
                          border:
                            selectedColor === color
                              ? "4px solid #000"
                              : "2px solid #ccc",
                          boxShadow:
                            selectedColor === color
                              ? "0 0 10px rgba(0,0,0,0.5)"
                              : "",
                          transition: "all 0.2s ease-in-out",
                        }}
                      ></div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          )}
          <div className="flex-1 mx-2 mb-1 mt-3">
            {renderGarmentRemarksDataOne()}
            {renderGarmentRemarksDataTwo()}
            {renderGarmentRemarksDataThree()}
            {renderGarmentRemarksData()}
            {renderGarmentColorRemarksData()}
          </div>

          <div className="flex-1 mx-2 mb-1 mt-3">
            <div className="border-round-xl shadow-2">
              <InputText
                style={{ width: "100%" }}
                id="GarmentRemark"
                value={garmentRemarkValue}
                placeholder="Garment Remark"
                onChange={(e) => handleGarmentRemarkChange(e.target.value)}
              />
            </div>
          </div>
          <div className="flex-1 mx-2 mb-1 mt-3">
            <div className=" flex justify-content-center">
              <Button
                label="ADD & CONTINUE"
                onClick={(e) => handleAddGarment(e, "continue")}
                disabled={isGarmentButtonPressed}
                className=" text-xl w-full border-round-xl border-none cursor-pointer mr-2"
              ></Button>
              <Button
                label="ADD & CLOSE"
                onClick={(e) => handleAddGarment(e, "close")}
                disabled={isGarmentButtonPressed}
                className=" text-xl w-full border-round-xl border-none cursor-pointer ml-2"
              ></Button>
            </div>
          </div>
        </div>
        <BookNewOrderModal
          setModalVisible={setModalVisible}
          modalVisible={modalVisible}
          onClose={onClose}
          status={modalStatus}
        />
        <BookNewOrderModal
          setModalVisible={setModalVisibleContinue}
          modalVisible={modalVisibleContinue}
          onClose={onClose}
          status={modalStatus}
        />
      </div>
    </div>
  );
};

export default BottomSheetViewForm;
